<script lang="ts">
	import Image from '../../components/image/ImageCms.svelte'
	import StructuredText from '../../components/structuredText/StructuredText.svelte'
	import { type IconImageBoxRecord } from 'datocms/models'

	interface Props {
		customContent: IconImageBoxRecord[]
	}

	let { customContent }: Props = $props()
</script>

<div class="flex flex-col gap-6 text-left">
	{#each customContent as item}
		<div
			class="grid grid-cols-1 rounded-md border border-dashed border-gray-200
						p-4"
		>
			<div class="m-auto mb-4">
				<Image image={item.image} />
			</div>

			<div class="font-display mb-3 flex gap-2 text-lg font-bold">
				<Image image={item.headlineIcon.image} />
				<StructuredText structuredText={item.headline.value} />
			</div>

			<div class="">
				<StructuredText structuredText={item.description.value} />
			</div>
		</div>
	{/each}
</div>
